export enum PointServiceType {
  internet = 'internet',
  airport = 'airport',
  hotel = 'hotel',
  destination = 'destination',
  selected = 'selected',
}
